import React from "react";
import "./Education.css";
import { education, achievements } from "../data/portfolioData";
import { HiAcademicCap, HiBadgeCheck, HiCalendar, HiSparkles } from "react-icons/hi";

function Education() {
  return (
    <section id="education" className="education-section section">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">Academics & Competitive Coding</span>
          <h2 className="section-title">Education & Achievements</h2>
          <p className="section-subtitle">
            Formal engineering foundations combined with algorithmic problem-solving milestones.
          </p>
        </div>

        <div className="education-achievements-grid">
          {/* Education Card */}
          <div className="education-card">
            <div className="card-badge-row">
              <span className="edu-icon-box">
                <HiAcademicCap size={24} />
              </span>
              <span className="edu-cgpa-pill">CGPA: {education.cgpa}</span>
            </div>

            <h3 className="edu-degree">{education.degree}</h3>
            <h4 className="edu-institution">{education.institution}</h4>

            <div className="edu-meta">
              <HiCalendar size={16} />
              <span>{education.period}</span>
            </div>

            <p className="edu-description">
              Rigorous grounding in data structures, algorithms, operating systems, database management,
              and computer networks.
            </p>
          </div>

          {/* Achievements Container */}
          <div className="achievements-card">
            <div className="achievements-header">
              <span className="achieve-icon-box">
                <HiSparkles size={24} />
              </span>
              <h3 className="achieve-title">Achievements</h3>
            </div>

            <div className="achievements-list">
              {achievements.map((item, index) => (
                <div key={index} className="achievement-row">
                  <div className="achieve-check">
                    <HiBadgeCheck size={20} />
                  </div>
                  <div className="achieve-content">
                    <h4 className="achieve-name">{item.title}</h4>
                    <span className="achieve-context">{item.context}</span>
                    <p className="achieve-detail">{item.detail}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Education;
